module.exports = __webpack_public_path__ + "media/src/assets/Images/Rooms-5b5bd72ff9c956bb315dda9e760af5ab.svg";